export { Illustration } from './Illustration';
export type { IllustrationName, IllustrationProps } from './Illustration';
import { illustrations } from './illustrations';
export const illustrationNames = Object.keys(illustrations) as Array<
    keyof typeof illustrations
>;
